module.exports = __webpack_public_path__ + "h.no2.b350053b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/h.no2.jpg
// module id = VNFW
// module chunks = 0